export const ADD_ITEM = 'ADD_ITEM';
export const CLEAR_CART = 'CLEAR_CART';
export const DEC_QTY = 'DEC_QTY';

export const SET_LOGIN_ERROR = 'SET_LOGIN_ERROR';

export const ADD_CUSTOMER = 'ADD_CUSTOMER';
export const REMOVE_CUSTOMER = 'REMOVE_CUSTOMER';
export const UPDATE_CUSTOMER = 'UPDATE_CUSTOMER';


// WEBPACK FOOTER //
// ./src/actions/types.js